import * as React from "react";

interface P {
    fn: () => void;
    next: () => any;
    runOnMount?: boolean;
}

interface S {
}

export class UseEffect extends React.Component<P, S> {

    componentDidMount(): void {
        if (this.props.runOnMount) {
            this.props.fn();
        }
    }

    componentDidUpdate(): void {
        this.props.fn();
    }

    render() {
        const {next} = this.props;

        return next();
    }
}

